import { Plugin } from "@ckeditor/ckeditor5-core";

export default class ItalicsAsEmPlugin extends Plugin {
  init() {
    this.editor.conversion.for("downcast").attributeToElement({
      model: "italic",
      view: "em",
      converterPriority: "high",
    });
  }
}
